import { gql } from "@apollo/client";

export const FoodFragment = gql`
  fragment FoodFragment on Food {
    id
    foodId
    name
    serving
    calories
    protein
    carbs
    fat
    fiber
    count
    usedAt
  }
`;

// What the organization has logged before, most recent first: the Foods
// screen, and the add-food form's picker.
export const list = gql`
  query FoodsList {
    viewer {
      id
      account {
        id
        foods {
          id
          list {
            ...FoodFragment
          }
        }
      }
    }
  }
  ${FoodFragment}
`;

export const remove = gql`
  mutation FoodsRemove($input: FoodRemoveInput!) {
    viewer {
      account {
        foods {
          remove(input: $input) {
            ...FoodFragment
          }
        }
      }
    }
  }
  ${FoodFragment}
`;

// A removal answers with the list as it now is, but a list is not one cached
// object Apollo could replace in place, so the read is run again.
export const AFTER_REMOVE = { refetchQueries: ["FoodsList"] };
